import { Button, Grid, Menu, MenuItem, Typography } from "@mui/material";
import { useMemo, useRef, useState } from "react"
import * as yup from "yup";
import { ADMIN_FORM_MODES } from "../../../utils/constants";
import { createDialer, updateDialer } from "../../../services/api-service";
import { showErrorNotification, showSuccessNotification } from "../../../components/admin/common/NotiService";
import { Formik } from "formik";
import OZInput from "../../../components/admin/common/OZInput";
import OZDialog from "../../../components/admin/common/OZDialog";
import OZDrawer from "../../../components/admin/common/OZDrawer/OZDrawer";
import '../addWidget/WidgetReportForm.css';
import LoadingScreen from "../../../components/admin/common/OZLoadingScreen/OZLoadingScreen";

const DialerViewDrawer = (widgetViewProps) => {
    return (<div style={{ maxHeight: "60vh", overflowY: "auto", padding: "10px", width: "29rem", }}>
        <Grid container={true} spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
                <Grid item xs={12} sm={12} md={12} lg={12} marginTop={"0.313rem"}>
                    <label className="oz-administration-view-Header">Dialer Name</label>
                </Grid>
                <label className="oz-adminstar">{widgetViewProps?.data.dialerName}</label>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
                <Grid item xs={12} sm={12} md={12} lg={12} marginTop={"0.313rem"}>
                    <label className="oz-administration-view-Header">Dialer Ip</label>
                </Grid>
                <label className="oz-adminstar">{widgetViewProps?.data.dialerIp}</label>
            </Grid>
        </Grid>
    </div>)
}

const DialerForm = (props) => {

    let initMode = props.data ? ADMIN_FORM_MODES.view : ADMIN_FORM_MODES.add;

    const [reportFormMode, setReportFormMode] = useState(initMode);
    const [open, setState] = useState(true);
    const [loading, setLoading] = useState(false);

    const validationSchema = useMemo(() =>
        yup.object({
            dialerName: yup
                .string("Enter Dialer Name")
                .min(2, "Dialer Name should be between 2 to 50 alphanumeric characters long")
                .max(50, "Dialer Name should be between 2 to 50 alphanumeric characters long")
                .matches(/^([A-Za-z0-9]((\_|-)?[A-Za-z0-9])+)$/, "Dialer Name should be between 2 to 50 alphanumeric characters long and allows special characters like _,-")
                .required("DialerName is required")
                .test('no-emoji', 'Emojis are not allowed', function (value) {
                    if (!value) return true;
                    return !/\p{Extended_Pictographic}/u.test(value);
                }),
            dialerIp: yup
                .string("Enter Dialer IP")
                .min(2, "Dialer IP should be between 2 to 255 characters")
                .max(255, "Dialer IP should be between 2 to 255 characters")
                .matches(/^[^\s]+$/, "Dialer IP should not contain spaces")
                .required("DialerIP is required")
                .test('no-emoji', 'Emojis are not allowed', function (value) {
                    if (!value) return true;
                    return !/\p{Extended_Pictographic}/u.test(value);
                })
        }), []
    );

    let styleEditButton = useMemo(() => ({
        fontWeight: '400',
        fontSize: '14px',
        color: '#3D8BF8',
    }), []);

    const closeReportForm = () => {
        props.onClose();
        setState(false);
        localStorage.removeItem("dialerForm");
    }

    const onClickEditButton = () => {
        setReportFormMode(ADMIN_FORM_MODES.edit);
    }

    const onClickDiscardButton = () => {
        setReportFormMode(ADMIN_FORM_MODES.view);
    }

    async function addDialer(data) {
        setLoading(true);
        try {
            createDialer(data).then((resp) => {
                if (resp.Status === "Success") {
                    closeReportForm();
                    props.refreshList();
                    showSuccessNotification(resp.Message);
                }
                else {
                    showErrorNotification(JSON.stringify(resp.Message));
                }
                setLoading(false);
            }).catch((e) => {
                setLoading(false);
                showErrorNotification(JSON.stringify(e))
            })
        }
        catch (e) {
            setLoading(false);
            showErrorNotification(JSON.stringify(e));
        }
    };

    async function updateDialerData(data) {
        setLoading(true);
        try {
            updateDialer(data).then((resp) => {
                if (resp.Status === "Success") {
                    closeReportForm();
                    props.refreshList();
                    showSuccessNotification(resp.Message);
                }
                else {
                    showErrorNotification(JSON.stringify(resp.Message));
                }
                setLoading(false);
            }).catch((e) => {
                setLoading(false);
                showErrorNotification(JSON.stringify(e));
            })
        }
        catch (e) {
            setLoading(false);
            showErrorNotification(JSON.stringify(e));
        }
    };

    let buttonStyle = useMemo(() => ({
        borderRadius: "0.5rem",
        height: "2.75rem",
        fontSize: "0.875rem",
        fontWeight: 400,
    }), []);

    const DataForm = (props) => {
        let initData = props.data ||
        {
            dialerName: '',
            dialerIp: ''
        };

        let style1 = useMemo(() => ({
            width: '400px',
            minHeight: "20vh",
            paddingtop: "10px"
        }), [])

        let style2 = useMemo(() => ({
            minHeight: '40vh',
            padding: '5px'
        }), [])

        function getInitData() {
            let localData = localStorage.getItem('dialerForm');
            if (localData) {
                return JSON.parse(localData);
            } else {
                return initData;
            }
        }

        return (<div className="ozReportAddForm">
            <Formik
                initialValues={getInitData()}
                validateOnMount
                validationSchema={validationSchema}
                onSubmit={(values) => {
                    if (reportFormMode === ADMIN_FORM_MODES.add || reportFormMode === ADMIN_FORM_MODES.edit) {
                        localStorage.setItem('dialerForm', JSON.stringify(values));
                    }
                    let finalData = structuredClone(values)
                    if (reportFormMode === ADMIN_FORM_MODES.add) {
                        addDialer(finalData);
                    }
                    else if (reportFormMode === ADMIN_FORM_MODES.edit) {
                        updateDialerData(finalData);
                    }
                }}>
                {(props) => (<form
                    onSubmit={props.handleSubmit}
                    id="dialerForm"
                    className="ozcw-scrollbar"
                    style={reportFormMode === ADMIN_FORM_MODES.add ? style1 : style2}>
                    <Grid container spacing={2}>
                        <>
                        <Grid container spacing={2} sx={{marginTop: 2, padding: '5px', marginLeft: '2px'}}>
                            <Grid item xs={12}>
                                <OZInput
                                    name='dialerName'
                                    label='Dialer Name *'
                                    placeholder='Dialer Name'
                                    disabled={reportFormMode === ADMIN_FORM_MODES.edit}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <OZInput
                                    name='dialerIp'
                                    label='Dialer Ip *'
                                    placeholder='Dialer Ip'
                                />
                            </Grid>
                        </Grid>
                        {reportFormMode === ADMIN_FORM_MODES.edit &&
                            <Grid item xs={12}>
                                <div className="oz-administration-view-drawer-buttons-container">
                                    <Button sx={buttonStyle} variant="outlined" onClick={closeReportForm}>
                                        Cancel
                                    </Button>
                                    <Button sx={{ ...buttonStyle, marginLeft: "10px" }} variant="contained" type="submit" form="dialerForm"
                                        onClick={() => {
                                            if (!props.isValid) {
                                                showErrorNotification("Please Check the values and fill all the mandatory field");
                                            }
                                        }}
                                    >
                                        Save
                                    </Button>
                                </div>
                            </Grid>
                        }
                        {loading ?
                            <div style={{ position: 'fixed', top: '0', left: '0', width: '100%', height: '100%', backgroundColor: '0,0,0,0.5', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 }} >
                                <LoadingScreen />
                            </div>
                            :
                            null
                        }
                        </>
                    </Grid>
                </form>)}
            </Formik>
        </div>)
    };

    return (<div>
        <div>
            {reportFormMode === ADMIN_FORM_MODES.add && (
                <OZDialog
                    title="Add Dialer"
                    open={open}
                    onClose={closeReportForm}
                    saveButtonProps={{
                        form: 'dialerForm',
                        type: 'submit',
                        label: 'save'
                    }}>
                    {reportFormMode === ADMIN_FORM_MODES.add && <DataForm />}
                </OZDialog>
            )}
        </div>
        {reportFormMode !== ADMIN_FORM_MODES.add &&
            <OZDrawer
                open={open}
                title={
                    <div style={{ width: "100%" }}>
                        <div className="oz-adminstration-drawer-title-container">
                            {reportFormMode !== ADMIN_FORM_MODES.edit &&
                                <Typography
                                    sx={{
                                        fontWeight: 600,
                                        fontSize: '18px',
                                        alignSelf: 'center',
                                        marginLeft: "10px"
                                    }}
                                >
                                    {props?.data?.dialerName}
                                </Typography>}
                        </div>
                        <div>
                            {reportFormMode === ADMIN_FORM_MODES.edit && (<Typography
                                size="small"
                                variant="text"
                                sx={{
                                    ...styleEditButton,
                                    marginLeft: "362px",
                                    marginTop: "14px",
                                    position: "absolute",
                                    cursor: "pointer"
                                }}
                                onClick={onClickDiscardButton}
                            >
                                Discard
                            </Typography>)}
                        </div>
                    </div>
                }
                onClose={closeReportForm}
                onEdit={onClickEditButton}
                mode={reportFormMode}
            >
                {reportFormMode !== ADMIN_FORM_MODES.edit && <DialerViewDrawer data={props.data} />}
                {reportFormMode === ADMIN_FORM_MODES.edit && <DataForm data={props.data} />}
            </OZDrawer >}
    </div>)
};
export default DialerForm